<ng-container *transloco="let t">
  <div class="dialog-overlay" (click)="onOverlayClick($event)">
    <div
      class="dialog-container"
      role="dialog"
      aria-modal="true"
      [attr.aria-labelledby]="titleId"
      [attr.aria-describedby]="descriptionId"
      cdkTrapFocus
      (click)="$event.stopPropagation()">
      <!-- Header -->
      <div class="dialog-header">
        <h2 class="dialog-title" [id]="titleId">
          @if (isIndividual) {
            {{ t('lang.waiver_type_title_individual') }}
          } @else {
            {{ t('lang.waiver_type_title_business') }}
          }
        </h2>
        <p class="dialog-subtitle" [id]="descriptionId">
          @if (isIndividual) {
            {{
              t(waiverTypeSubtitleIndividualKey, {
                partner: partnerName,
                entity: integrationEntityName,
              })
            }}
          } @else {
            {{
              t(waiverTypeSubtitleBusinessKey, {
                partner: partnerName,
                entity: integrationEntityName,
              })
            }}
          }
        </p>
        <button class="close-button" (click)="onCancel()" type="button" cdkFocusInitial>
          <mzic-svg src="assets/icons/mzic-close.svg" />
        </button>
      </div>

      <!-- Content -->
      <div class="dialog-content">
        <!-- Type Selection Cards -->
        <div class="type-cards">
          <!-- Rightsholder Option -->
          <div
            class="type-card"
            [class.selected]="selectedType() === 'rightsholder'"
            (click)="selectType('rightsholder')">
            <div class="card-radio">
              <span class="radio-outer">
                <span class="radio-inner"></span>
              </span>
            </div>
            <div class="card-content">
              <h3 class="card-title">
                @if (isIndividual) {
                  {{ t('lang.waiver_type_rightsholder_individual') }}
                } @else {
                  {{ t('lang.waiver_type_rightsholder_business') }}
                }
              </h3>
              <p class="card-description">
                @if (isIndividual) {
                  {{
                    t('lang.waiver_type_rightsholder_desc_individual', {
                      alias: userName,
                    })
                  }}
                } @else {
                  {{ t('lang.waiver_type_rightsholder_desc_business') }}
                }
              </p>
            </div>
          </div>

          <!-- Representative Option -->
          <div
            class="type-card"
            [class.selected]="selectedType() === 'representative'"
            (click)="selectType('representative')">
            <div class="card-radio">
              <span class="radio-outer">
                <span class="radio-inner"></span>
              </span>
            </div>
            <div class="card-content">
              <h3 class="card-title">{{ t('lang.waiver_type_representative') }}</h3>
              <p class="card-description">
                {{ t('lang.waiver_type_representative_desc') }}
              </p>
            </div>
          </div>
        </div>

        <!-- CPF Input (shown when representative is selected) -->
        @if (isRepresentativeSelected) {
          <lib-waiver-cpf-field
            [control]="cpfControl"
            [sectionTitle]="cpfSectionTitle"
            [label]="t('lang.cpf_input_label')"
            [placeholder]="t('lang.cpf_input_placeholder')"
            [invalidError]="t('lang.cpf_input_invalid_error')"
            [privacyInfo]="t(cpfInputPrivacyInfoKey, { entity: integrationEntityName })">
          </lib-waiver-cpf-field>
        }
      </div>

      <!-- Footer -->
      <div class="dialog-footer">
        <button
          class="primary-button"
          [disabled]="!canContinue"
          (click)="onConfirm()"
          type="button">
          @if (loading) {
            <mzic-spinner />
            {{ t('lang.waiver_generating') | uppercase }}
          } @else {
            {{ t('lang.continue') | uppercase }}
          }
        </button>
      </div>
    </div>
  </div>
</ng-container>
